import * as React from 'react';
import { Icon } from './Icon';
import { cn } from '@/lib/utils';

interface StepperProps {
  step: number;
  labels: string[];
  /**
   * Compact mode hides the step label and lets the connector line stretch —
   * used in the mobile header where vertical room is scarce.
   */
  compact?: boolean;
  className?: string;
}

export function Stepper({ step, labels, compact, className }: StepperProps) {
  return (
    <div className={cn('flex items-center', compact ? 'gap-1.5' : 'gap-2.5', className)}>
      {labels.map((label, i) => {
        const n = i + 1;
        const done = n < step;
        const active = n === step;
        const filled = done || active;
        return (
          <React.Fragment key={label}>
            <div className="flex min-w-0 items-center gap-2">
              <div
                className={cn(
                  'flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full border text-[11px] font-semibold',
                  filled
                    ? 'border-ink bg-ink text-accent-foreground'
                    : 'border-line-2 bg-paper text-muted',
                )}
              >
                {done ? <Icon name="check" size={12} strokeWidth={2.6} /> : n}
              </div>
              {!compact && (
                <span
                  className={cn(
                    'whitespace-nowrap text-[12.5px] tracking-[-0.01em]',
                    active ? 'font-semibold text-ink' : done ? 'text-ink-2' : 'text-muted',
                  )}
                >
                  {label}
                </span>
              )}
            </div>
            {i < labels.length - 1 && (
              <div
                className={cn(
                  'h-px min-w-[12px]',
                  done ? 'bg-ink' : 'bg-line',
                  compact ? 'flex-1' : 'w-5',
                )}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
